import { object, ObjectSchema, string } from 'yup';

import { OfferOverrides } from './overrides.types';
import { OfferPresentationPriority, OfferPresentationType } from '../../../../graphql/types.generated';

export const OfferOverridesSchema: ObjectSchema<OfferOverrides> = object({
  presentationPriority: string().equals(Object.values(OfferPresentationPriority)).optional(),
  presentationType: string().equals(Object.values(OfferPresentationType)).optional(),
})
  .strict()
  .noUnknown();
